import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { authTokenState } from 'features/auth/state/authAtoms';
import { fetchErrorCodes } from 'features/error-codes/api/fetchErrorCodes';
import {
  errorCodesErrorState,
  errorCodesLoadingState,
  errorCodesState,
} from 'features/error-codes/state/errorCodesAtoms';

// 辞書はアプリ寿命中不変のため authToken をトリガに 1 回だけ取得し、
// 通常の renderKey 再取得サイクルには載せない。
export const useFetchErrorCodes = () => {
  const authToken = useRecoilValue(authTokenState);
  const setErrorCodes = useSetRecoilState(errorCodesState);
  const setLoading = useSetRecoilState(errorCodesLoadingState);
  const setError = useSetRecoilState(errorCodesErrorState);

  useEffect(() => {
    if (authToken === '') {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    void fetchErrorCodes(authToken).then((result) => {
      if (cancelled) return;
      setErrorCodes(result.codes);
      setError(result.errorMessage);
      setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, [authToken, setErrorCodes, setError, setLoading]);
};
